import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleChartsScatterChartComponent } from './google-charts-scatter-chart/google-charts-scatter-chart.component';
import { GoogleChartsColumnChartComponent } from './google-charts-column-chart/google-charts-column-chart.component';
import { GoogleChartsLineChartComponent } from './google-charts-line-chart/google-charts-line-chart.component';
import { GoogleChartsCustomTooltipComponent } from './google-charts-custom-tooltip/google-charts-custom-tooltip.component';

@NgModule({
	declarations: [
		GoogleChartsScatterChartComponent,
		GoogleChartsColumnChartComponent,
		GoogleChartsLineChartComponent,
		GoogleChartsCustomTooltipComponent
	],
	imports: [CommonModule],
	exports: [
		GoogleChartsScatterChartComponent,
		GoogleChartsColumnChartComponent,
		GoogleChartsLineChartComponent
	]
})
export class GoogleChartsModule { }
